import { OrderStatsDataRow } from '@warebee/shared/dataset-queries';
import { useTranslation } from 'react-i18next';
import useFormatter from '../common/useFormatter';
import { ColumnConfig } from '../components/DatasetTable';
import ItemCategoryTag from '../components/table/ItemCategoryTag';

function useOrderStatsDataTableConfig(): ColumnConfig<OrderStatsDataRow>[] {
  const { t } = useTranslation('dataset');
  const formatter = useFormatter();

  const columnsConfig: ColumnConfig<OrderStatsDataRow>[] = [
    {
      field: 'cumulativePercentRank',
      title: t`ABC Cumulative Percent Rank`,
      hasSort: false,
      hiddenInExport: true,
      render: (v: number) => <ItemCategoryTag cmlPercent={v} />,
    },
    {
      field: 'categoryABC',
      title: t`ABC (Category)`,
      hiddenInBrowser: true,
    },
    {
      field: 'orderLineCount',
      title: t`Order Line Count`,
    },
    {
      field: 'quantityOrdered',
      title: t`Quantity Ordered`,
    },
    {
      field: 'percentRank',
      title: t`ABC Percent Rank`,
      render: (v: number) => formatter.formatShare(v).fullString,
    },

    {
      field: 'totalDaysOrdered',
      title: t`Total Days with Orders`,
    },
    {
      field: 'totalWeeksOrdered',
      title: t`Total Weeks with Orders`,
    },
    {
      field: 'avgDailyLinesCount',
      title: t`Daily Order Lines (Avg)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'maxDailyLinesCount',
      title: t`Daily Order Lines (Max)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'minDailyLinesCount',
      title: t`Daily Order Lines (Min)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    // {
    //   field: 'details.dailyStats.orderLineCount.cv',
    //   title: t`Daily Orders CV`,
    //   render: (v: number) => formatter.formatNumber(v, 1).fullString,
    // },

    {
      field: 'avgWeeklyLinesCount',
      title: t`Weekly Order Lines (Avg)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'maxWeeklyLinesCount',
      title: t`Weekly Order Lines (Max)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'minWeeklyLinesCount',
      title: t`Weekly Order Lines (Min)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
  ];

  return columnsConfig;
}
export default useOrderStatsDataTableConfig;
